<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item :to="{ path: '/main' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>
      <a href="/">报名管理</a>
    </el-breadcrumb-item>
    <el-breadcrumb-item>报名列表</el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  name: 'Breadcrumb'
}
</script>

<style scoped>
.el-aside {
  color: #333;
}
</style>
